export default __webpack_public_path__ + "574de04a559802ef594ca1ad02d3ccc1.svg";